import { useLayoutEffect } from "react";

import {
  resolveTheme,
  THEME_COLORS,
  useSystemDark,
  useThemePreference,
  type ResolvedTheme,
} from "./theme";

export function applyTheme(theme: ResolvedTheme): void {
  const root = document.documentElement;
  root.classList.toggle("dark", theme === "dark");
  root.style.colorScheme = theme;
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", THEME_COLORS[theme]);
}

/**
 * Puts the `dark` class on <html>, not on a wrapper, because dialogs, sheets and
 * toasts are portalled to <body> and a wrapper would leave them light. It renders
 * nothing; index.html has already set the class for first paint, and this keeps it
 * right after navigation, a change in the switch, or a change in the phone setting.
 */
export function ThemeController() {
  const [preference] = useThemePreference();
  const systemDark = useSystemDark();
  const theme = resolveTheme({ preference, systemDark });
  // A layout effect, so a change of theme does not paint a frame in the old one.
  useLayoutEffect(() => applyTheme(theme), [theme]);
  return null;
}
